/* Teeinblue: lock addon charge line items inside the mini cart / cart drawer.
   The SDK only locks rows matching .Cart__Item / .cart-item / .cart__item.
   This theme renders drawer rows as <li class="mini-cart__item">, so the SDK never
   reaches them and buyers can change the addon quantity, then check out before the
   cart autofixer restores it. */
(function () {
  'use strict';

  // Guard against the file being loaded twice
  if (window.tibAddonLockLoaded) return;
  window.tibAddonLockLoaded = true;

  // Line item property present ONLY on addon charge lines
  var ADDON_PROP = '_tib_customization_id';
  var LOCK_CLASS = 'tib-addon-locked';

  var ROW_SELECTOR = [
    '.mini-cart__item',
    '[data-cart-item]',
    '.cart__item',
    '.cart-item',
    '.Cart__Item',
    '.cart__row'
  ].join(', ');

  var CONTROL_SELECTOR = [
    '.product-quantity-box',
    '.js-change-quantity',
    '.cart__remove-btn',
    '.js-cart-remove-btn',
    '[data-remove-item]',
    'a[href*="/cart/change"]',
    'input[name^="updates"]'
  ].join(', ');

  var addonLines = {};    // { "2": true } - addon line numbers, in cart order
  var addonVariants = {}; // { "48064787218606": true } - addon variant ids
  var fetching = false;
  var applyTimer = null;
  var refreshTimer = null;

  function injectStyle() {
    if (document.getElementById('tib-addon-lock-style')) return;

    var css =
      '.' + LOCK_CLASS + ' .product-quantity-box,' +
      '.' + LOCK_CLASS + ' .js-change-quantity,' +
      '.' + LOCK_CLASS + ' .cart__remove-btn,' +
      '.' + LOCK_CLASS + ' .js-cart-remove-btn,' +
      '.' + LOCK_CLASS + ' [data-remove-item],' +
      '.' + LOCK_CLASS + ' a[href*="/cart/change"]{' +
      'display:none !important;visibility:hidden !important;pointer-events:none !important;}' +
      '.' + LOCK_CLASS + ' .tib-hidden-prop{display:none !important;}';

    var style = document.createElement('style');
    style.id = 'tib-addon-lock-style';
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }

  // Read the cart and remember which lines / variants are addon charges.
  // byTeeinblue tells the Teeinblue SDK to ignore this request, so it does not
  // fire its cart-ajax event (and does not re-init its own cart service) for it.
  function refreshCart() {
    if (fetching || typeof fetch !== 'function') return;
    fetching = true;

    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin', byTeeinblue: true })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        addonLines = {};
        addonVariants = {};
        (cart.items || []).forEach(function (item, index) {
          var props = item.properties || {};
          if (props[ADDON_PROP]) {
            addonLines[String(index + 1)] = true;
            addonVariants[String(item.id)] = true;
          }
        });
      })['catch'](function () {})
      .then(function () { fetching = false; apply(); });
  }

  // Coalesce bursts of cart events into a single request
  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 250);
  }

  function isAddonRow(row) {
    var line = row.getAttribute && row.getAttribute('data-line-id');
    if (line && addonLines[line]) return true;

    var variantId = row.getAttribute && row.getAttribute('data-variant-id');
    if (variantId && addonVariants[variantId]) return true;

    var removeLink = row.querySelector('a[href*="/cart/change"]');
    if (removeLink) {
      var lineMatch = /[?&]line=(\d+)/.exec(removeLink.getAttribute('href') || '');
      if (lineMatch && addonLines[lineMatch[1]]) return true;
    }

    var qtyInput = row.querySelector('input[name^="updates"][id]');
    if (qtyInput) {
      var idMatch = /updates_(\d+)/.exec(qtyInput.id || '');
      if (idMatch && addonVariants[idMatch[1]]) return true;
    }

    // Fallback: the JS-rendered mini cart prints line item properties into the DOM
    if ((row.textContent || '').indexOf(ADDON_PROP) !== -1) return true;

    return false;
  }

  function lock(row) {
    if (row.classList.contains(LOCK_CLASS)) return;
    row.classList.add(LOCK_CLASS);

    var controls = row.querySelectorAll(CONTROL_SELECTOR);
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];

      if (control.tagName === 'INPUT') {
        // Do NOT use disabled here: updates[] is a positional array, so a disabled
        // input would shift the values and Shopify could drop the addon line when
        // the mini cart form is submitted (Checkout button). Read-only still submits.
        control.readOnly = true;
        control.setAttribute('tabindex', '-1');
        control.style.pointerEvents = 'none';
      } else {
        control.style.display = 'none';
        control.setAttribute('aria-hidden', 'true');
        if (control.tagName === 'A') control.removeAttribute('href');
      }
    }

    // Hide internal properties when the theme prints them
    var props = row.querySelectorAll(
      '.mini-cart__item-property, .cart__item-property, .product-details__item, .cart-item__property'
    );
    for (var j = 0; j < props.length; j++) {
      var text = props[j].textContent || '';
      if (text.indexOf('_tib') !== -1 || text.indexOf('_customization') !== -1) {
        props[j].classList.add('tib-hidden-prop');
      }
    }
  }

  function apply() {
    injectStyle();
    var rows = document.querySelectorAll(ROW_SELECTOR);
    for (var i = 0; i < rows.length; i++) {
      if (isAddonRow(rows[i])) lock(rows[i]);
    }
  }

  function scheduleApply() {
    if (applyTimer) clearTimeout(applyTimer);
    applyTimer = setTimeout(apply, 30);
  }

  // Capture-phase guard, in case the theme re-renders faster than the observer
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('.' + LOCK_CLASS) && target.closest(CONTROL_SELECTOR)) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }
  }, true);

  // The theme rebuilds the drawer with innerHTML, so re-apply on every DOM change.
  // This is DOM only - it never triggers a network request.
  if (window.MutationObserver) {
    new MutationObserver(scheduleApply).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // Refresh the map only when the cart actually changes.
  // Never listen to 'shopify-event-cart-ajax': the SDK fires it for ANY /cart.js
  // request - including this one - which creates an endless refresh loop.
  document.addEventListener('teeinblue-event-after-cart-added', scheduleRefresh);
  document.addEventListener('shopify-event-cart-modified', scheduleRefresh);
  window.addEventListener('pageshow', scheduleRefresh);

  refreshCart();
  apply();
})();

// Reload the mini cart / cart drawer via the Shopify Section Rendering API
window.tibReloadCartDrawer = function () {
  var anchor = document.querySelector('.js-cart_items') || document.querySelector('[data-cart-form="mini-cart"]');
  var section = anchor && anchor.closest('[id^="shopify-section-"]');
  if (!section) return Promise.resolve(false);

  var sectionId = section.id.replace('shopify-section-', '');

  return fetch('/?sections=' + encodeURIComponent(sectionId), { cache: 'no-store', credentials: 'same-origin' })
    .then(function (res) { return res.ok ? res.json() : null; })
    .then(function (json) {
      if (!json) return false;
      var doc = new DOMParser().parseFromString(json[sectionId] || '', 'text/html');

      ['.js-cart_items', '.js-cart_discounts', '.js-cart_subtotal', '.js-cart_savings', '.cart_count']
        .forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          if (!fresh) return;
          document.querySelectorAll(sel).forEach(function (el) { el.innerHTML = fresh.innerHTML; });
        });

      [['.js-empty-cart__message', 'hidden'], ['[data-cart-form="mini-cart"]', 'hidden']]
        .forEach(function (pair) {
          var fresh = doc.querySelector(pair[0]);
          if (!fresh) return;
          var shouldHide = fresh.classList.contains(pair[1]);
          document.querySelectorAll(pair[0]).forEach(function (el) { el.classList.toggle(pair[1], shouldHide); });
        });

      return true;
    })['catch'](function () { return false; });
};

window.teeinblue = {
    ...(window.teeinblue || {}),
    autofixerDelay: 2000,
    autofixerCallback: () => {
        console.log('===autofixer done');
        
        if (/\/cart/.test(window.location.href)) {
          location.reload();
        } else if (window.tibReloadCartDrawer) {
          window.tibReloadCartDrawer();
        }
    }
}